import { User } from 'oidc-client-ts';

import { AppConfig } from 'src/config/types';
import { APP_CONFIG_STORAGE_KEY } from 'src/constants';

const getUserToken = () => {
  const configData = localStorage.getItem(APP_CONFIG_STORAGE_KEY);

  /* istanbul ignore if -- @preserve */
  if (!configData) return null;

  const config: AppConfig = JSON.parse(configData);
  const {
    auth: { authority, clientId },
  } = config;

  const storageKey = `oidc.user:${authority}:${clientId}`;
  const oidcStorage = sessionStorage.getItem(storageKey);

  /* istanbul ignore else -- @preserve */
  if (!oidcStorage) {
    return null;
  }

  return User.fromStorageString(oidcStorage).access_token;
};

interface ApiRequestProps<InputData> {
  additionalHeaders?: RequestInit['headers'];
  data?: InputData;
  method?: 'DELETE' | 'GET' | 'PATCH' | 'POST' | 'PUT';
  url: string;
}

export const apiRequest = async <ResponseData, InputData = unknown>({
  additionalHeaders,
  data,
  method = 'GET',
  url,
}: ApiRequestProps<InputData>) => {
  const token = getUserToken();

  const response = await fetch(url, {
    body: data && JSON.stringify(data),
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      ...additionalHeaders,
    },
    method,
  });

  if (!response.ok) {
    throw response;
  }

  const responseText = await response.text();

  // Some successful requests return no content (for example 202/204).
  if (!responseText) {
    return undefined as ResponseData;
  }

  return JSON.parse(responseText) as ResponseData;
};
